import React, { Component } from 'react'
import Candidat from './Candidat';
import Journee from './Journee';
import CycleIngenieur from './CycleIngenieur';
import Confirmation from './Confirmation';
import axios from "axios";
import { ProgressBar } from "./ProgressBar"
import ReCAPTCHA from "react-google-recaptcha";
import Loading from './sub-components/Loading';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {

    gtmId: process.env.REACT_APP_GTM_ID,
    dataLayer: {
        test: "inscription"
    },
    dataLayerName: 'PageDataLayer'

}

TagManager.initialize(tagManagerArgs)

let idSource;
let idCampagne;
let idMedium;

export default class Inscription extends Component {

    

    constructor(props) {
        super(props);
        this.reCaptacha = React.createRef()
    }

    componentDidMount() {
        this.fetchData();
        this.getParametersFromURL();
    }
    // verification du type de journée d'information et assignation des valeurs 
    getParametersFromURL = () => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('journeeInformationEcole')) {
            this.setState({
                CodeTypeJourneeInformation: 1,       // 1 pour une journee d'information lycée / école
                idTypeFormation: 121133,             // code pour Formation en alternance
                idSituation: 121151,                 // code pour situation Etudiant.e
                etudeInformatique: true,             // etude en informatique
                displayCv: false                     // dépose du CV
            });
        }

        // récupération des paramètres de l'URL pour les campagnes
        if (urlParams.has('idSource') && urlParams.has('idCampagne') && urlParams.has('idMedium')) {
            idSource = urlParams.get('idSource');
            idCampagne = urlParams.get('idCampagne');
            idMedium = urlParams.get('idMedium');
        }
    }
    async fetchData() {
        const urls = [
            "api/v1/Inscription/GetJourneesTestInscriptions",
            "api/v1/ChoiceList/CIVILITE",
            "api/v1/ChoiceList/STATUT",
            "api/v1/ChoiceList/MODALITE_SOUHAITEE",
            "api/v1/ChoiceList/LIEU_PHYSIQUE",
            "api/v1/ChoiceList/DIPLOME_AUTRE_QUE_CP",
            "api/v1/ChoiceList/TYPE_FORMATION"
        ]

        Promise.all(urls.map(url => fetch(url)
            .then(res => res.json())
            .then(res => res)))
            .then(res => {
                let errorOnFetch = false;
                res.forEach(function (result) {
                    if (result.statusCode != 200) {
                        errorOnFetch = true;
                    }
                });
                this.setState({
                    filieres: res[0].result,
                    civilites: res[1].result,
                    situations: res[2].result,
                    modalites: res[3].result,
                    campus: res[4].result,
                    niveauxEtude: res[5].result,
                    typesFormations: res[6].result,
                    loading: false,
                    errorOnFetch: errorOnFetch
                });
                if (!errorOnFetch) {
                    this.setState({ step: 1 });
                }
            })
    }

    state = {
        CodeTypeJourneeInformation: 0,  // journée test classique
        //Etape
        step: 0,
        loading: true,
        errorOnFetch: false,
        maxStep: 3,
        erreurs: [],
        displayCv: true,
        displayLettre: false,
        etapeInscription: 0,
        //Formulaire
        idModaliteSuivi: 0,
        idCampus: 0,
        idTypeFormation: 0,
        idFiliere: 0,
        idFormation: 0,
        idJourneeTest: 0,
        idCivilite: 0,
        nom: "",
        prenom: "",
        adress: "",
        codepostal: "",
        ville: "",
        telephone: "",
        mail: "",
        naissance: "",
        idSituation: 0,
        idNiveauEtude: 0,
        etudeInformatique: false,
        salarieInformatique: false,
        cv: null,
        lettre: null,
        //Datas pour alimenter le formulaire
        modalites: [],
        campus: [],
        filieres: [],//contient aussi les formations et les dates
        civilites: [],
        situations: [],
        niveauxEtude: [],
        typesFormations: []
    };

    // go back to previous step
    prevStep = () => {
        const { step } = this.state;
        this.setState({ step: step - 1 });
    }

    // proceed to the next step
    nextStep = () => {
        // const { maxStep } = this.state;
        const { step } = this.state;
        var okPourNextStep = this.validerStep(step);
        if (okPourNextStep) {
            this.setState({ step: step + 1 });
        }
        else {
            this.setState({ step: step });
        }
    }

    validerChamp = (idChamp) => {

        if (this.state.erreurs.find(err => err.id == idChamp)) {
            this.state.erreurs.splice(this.state.erreurs.indexOf(this.state.erreurs.find(err => err.id == idChamp)), 1);
        }
        var retour = true;
        if (idChamp == "idModaliteSuivi" && this.state.idModaliteSuivi == 0) {
            this.state.erreurs.push({ id: "idModaliteSuivi", libelle: "Veuillez choisir une modalite de réalisation" });
            retour = false;
        }
        else if (idChamp == "idCampus" && this.state.idModaliteSuivi == 121581/*Présentiel*/ && this.state.idCampus == 0) {
            this.state.erreurs.push({ id: "idCampus", libelle: "Veuillez sélectionner un campus" });
            retour = false;
        }
        else if (idChamp == "idFiliere" && this.state.idFiliere == 0) {
            this.state.erreurs.push({ id: "idFiliere", libelle: "Veuillez sélectionner une filière" });
            retour = false;
        }
        else if (idChamp == "idFormation" && this.state.idFiliere > 0 && this.state.idFormation == 0) {
            this.state.erreurs.push({ id: "idFormation", libelle: "Veuillez sélectionner une formation" });
            retour = false;
        }
        else if (idChamp == "idTypeFormation" && this.state.idTypeFormation == 0) {
            this.state.erreurs.push({ id: "idTypeFormation", libelle: "Veuillez sélectionner une modalité de formation" });
            retour = false;
        }
        else if (idChamp == "idJourneeTest" && this.state.idFormation > 0 && this.state.idJourneeTest == 0) {
            this.state.erreurs.push({ id: "idJourneeTest", libelle: "Veuillez sélectionner une journée d'information" });
            retour = false;
        }
        else if (idChamp == "idCivilite" && this.state.idCivilite == 0) {
            this.state.erreurs.push({ id: "idCivilite", libelle: "Veuillez sélectionner votre civilité" });
            retour = false;
        }
        else if (idChamp == "nom" && this.state.nom == "") {
            this.state.erreurs.push({ id: "nom", libelle: "Veuillez renseigner votre nom" });
            retour = false;
        }
        else if (idChamp == "prenom" && this.state.prenom == "") {
            this.state.erreurs.push({ id: "prenom", libelle: "Veuillez renseigner votre prénom" });
            retour = false;
        }
        else if (idChamp == "adress" && this.state.adress == "") {
            this.state.erreurs.push({ id: "adress", libelle: "Veuillez renseigner votre Adresse" });
            retour = false;
        }
        else if (idChamp == "codepostal" && this.state.codepostal == "") {
            this.state.erreurs.push({ id: "codepostal", libelle: "Veuillez renseigner votre code postal" });
            retour = false;
        }
        else if (idChamp == "codepostal" && this.state.codepostal.length > 5) {
            this.state.erreurs.push({ id: "codepostal", libelle: "Le code postal ne doit pas dépasser 5 chiffres" });
            retour = false;
        }
        else if (idChamp == "ville" && this.state.ville == "") {
            this.state.erreurs.push({ id: "ville", libelle: "Veuillez renseigner votre ville" });
            retour = false;
        }
        else if (idChamp == "telephone" && this.state.telephone == "") {
            this.state.erreurs.push({ id: "telephone", libelle: "Veuillez renseigner votre téléphone" });
            retour = false;
        }
        else if (idChamp == "telephone" && this.state.telephone.length > 15) {
            this.state.erreurs.push({ id: "telephone", libelle: "le téléphone ne doit pas dépasser 15 chiffres" });
            retour = false;
        }
        else if (idChamp == "mail" && this.state.mail == "") {
            this.state.erreurs.push({ id: "mail", libelle: "Veuillez renseigner votre email" });
            retour = false;
        }
        else if (idChamp == "naissance" && this.state.naissance == "") {
            this.state.erreurs.push({ id: "naissance", libelle: "Veuillez renseigner votre date de naissance" });
            retour = false;
        }
        else if (idChamp == "naissance" && this.state.naissance != "") {
            let dateControle = new Date(this.state.naissance);
            let date16ans = new Date().setFullYear(new Date().getFullYear() - 16);
            let date64ans = new Date().setFullYear(new Date().getFullYear() - 64);
            if (dateControle > date16ans) {
                this.state.erreurs.push({ id: "naissance", libelle: "Votre devez avoir minimum 16 ans" });
                retour = false;
            }
            if (dateControle < date64ans) {
                this.state.erreurs.push({ id: "naissance", libelle: "Votre devez avoir moins de 64 ans" });
                retour = false;
            }
        }
        else if (idChamp == "mail") {
            let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!regex.test(this.state.mail)) {
                this.state.erreurs.push({ id: "mail", libelle: "Mail Invalide, veuillez en saisir un correct" });
                retour = false;
            }
        }

        else if (idChamp == "idSituation" && this.state.idSituation == 0) {
            this.state.erreurs.push({ id: "idSituation", libelle: "Veuillez renseigner votre situation" });
            retour = false;
        }
        else if (idChamp == "idNiveauEtude" && this.state.idSituation == 2 && this.state.idNiveauEtude == 0) {
            this.state.erreurs.push({ id: "idNiveauEtude", libelle: "Veuillez renseigner votre niveau d'étude" });
            retour = false;
        }
        else if (idChamp == "cv") {
            var fichierCv = this.state.cv;
            if (
                this.state.displayCv &&
                (fichierCv?.size > "8000000" ||
                    fichierCv?.type != "application/pdf")
            ) {
                this.state.erreurs.push({ id: "cv", libelle: "Votre CV doit être un pdf inférieur à 8Mo" });
                retour = false;
            }
        }
        else if (idChamp == "lettre") {
            var fichierLettre = this.state.lettre;
            if (
                this.state.displayLettre &&
                (fichierLettre?.size > "8000000" ||
                    fichierLettre?.type != "application/pdf")
            ) {
                this.state.erreurs.push({ id: "lettre", libelle: "Votre lettre de motivation doit être un pdf inférieur à 8Mo" });
                retour = false;
            }
        }
        return retour;
    }
    validerStep = (step) => {
        var retour = true;
        this.state.erreurs = [];
        if (step == 1) {
            retour = this.validerChamp("idModaliteSuivi") &
                this.validerChamp("idCampus") &
                this.validerChamp("idFiliere") &
                this.validerChamp("idFormation") &
                this.validerChamp("idTypeFormation") &
                this.validerChamp("idJourneeTest");
        }
        else if (step == 2) {
            retour = this.validerChamp("idCivilite") &
                this.validerChamp("nom") &
                this.validerChamp("prenom") &
                this.validerChamp("adress") &
                this.validerChamp("codepostal") &
                this.validerChamp("ville") &
                this.validerChamp("telephone") &
                this.validerChamp("mail") &
                this.validerChamp("naissance") &
                this.validerChamp("idSituation") &
                this.validerChamp("idNiveauEtude") &
                this.validerChamp("cv") &
                this.validerChamp("lettre");
            if (retour) {
                this.submitCandidatInformations();
            }
        }
        return retour;
    }

    submitCandidatInformations = async () => {

        const token = await this.reCaptacha.current.executeAsync();
        axios.post('api/v1/GoogleCaptcha',
            token, { headers: { 'Content-Type': 'application/json' } }
        ).then((response) => {
            if (response.status == 200) {
                const datasAPoster = {
                    idModaliteSuivi: this.state.idModaliteSuivi,//ok
                    idCampus: this.state.idCampus,//ok
                    idFormation: this.state.idFormation,//ok
                    idTypeFormation: this.state.idTypeFormation,//ok
                    idJourneeTest: this.state.idJourneeTest,//ok
                    idCivilite: this.state.idCivilite,//ok
                    nom: this.state.nom,//ok
                    prenom: this.state.prenom,//ok
                    adress: this.state.adress,
                    codepostal: this.state.codepostal,
                    ville: this.state.ville,
                    telephone: this.state.telephone,//ok
                    mail: this.state.mail,//ok
                    naissance: this.state.naissance,
                    idSituation: this.state.idSituation,//ok
                    idNiveauEtude: this.state.idNiveauEtude,//ok
                    etudeInformatique: this.state.etudeInformatique,//ok
                    salarieInformatique: this.state.salarieInformatique,//ok
                    UploadCv: this.state.displayCv,
                    UploadLettre: this.state.displayLettre
                };

                let url = "api/v1/Inscription/InscriptionCandidat";
                if (idSource && idCampagne && idMedium) {
                    url = url + `?idSource=${idSource}&idCampagne=${idCampagne}&idMedium=${idMedium}`;
                }

                this.setState({ etapeInscription: 1 });
                axios.post(url, datasAPoster)
                    .then((response) => {
                        if (response.data.result.statusCode != 200) {
                            //Afficher une erreur sur la page de confirmation
                            this.setState({ etapeInscription: 11 });
                        }
                        else {
                            //Afficher un succès d'inscription sur la page de confirmation
                            if (this.state.cv || this.state.lettre) {
                                //Afficher un message sur la page de confirmation indiquant le début de l'upload du CV et/ou lettre motivation
                                this.setState({ etapeInscription: 2 });
                                let urlUploadFiles = "api/v1/Inscription/UploadFiles";
                                const body = new FormData();
                                if (this.state.cv) body.append("Files", this.state.cv, "CVInscription.pdf");
                                if (this.state.lettre) body.append("Files", this.state.lettre, "LettreMotivationInscription.pdf");
                                body.append("IdPersonne", response.data.result.result);
                                axios.post(urlUploadFiles, body).then((response) => {
                                    if (response.data.result.statusCode != 200) {
                                        //Afficher une erreur sur la page de confirmation indiquant que l'upload du CV et/ou de la lettre de motivation a échoué mais que l'inscription a tout de mêm réussi
                                        this.setState({ etapeInscription: 21 });
                                    }
                                    else {
                                        //Afficher un message indiquant le succès de l'inscription et de l'upload des fichiers
                                        this.setState({ etapeInscription: 3 });
                                    }
                                });
                            }
                            else {
                                this.setState({ etapeInscription: 3 });
                            }
                        }
                    });
            }
            else {
                this.setState({ step: 2 });
            }
        });
    }

    handleErreur = (idErreur) => {
        return this.state.erreurs.map((erreur) => {
            if (erreur.id == idErreur)
                return <span style={{ color: "red" }} >{erreur.libelle}
                </span>;
        });
    }

    handleChange = input => e => {
        let majState = new Promise((resolve, reject) => {
            this.setState({ [input]: e.target.value });

            if ([input] == "idModaliteSuivi") {
                this.setState({ "idCampus": 0 });
            }
            else if ([input] == "idFiliere") {
                this.setState({ "idFormation": 0 });
                this.setState({ "idJourneeTest": 0 });
            }
            else if ([input] == "idFormation") {
                this.setState({ "idJourneeTest": 0 });

                if(e.target.value == 1400990 /*Bac+5 Dev*/ || e.target.value == 521 /*Bac+5 Res*/) {
                    this.setState({ "idTypeFormation": 121133 /*Formation en alternance*/});
                }
            }
            else if ([input] == "idSituation") {
                this.setState({ "idNiveauEtude": 0 });
                this.setState({ "etudeInformatique": false });
                this.setState({ salarieInformatique: false });
            }
            else if ([input] == "etudeInformatique" || [input] == "salarieInformatique") {
                this.setState({ [input]: e.target.checked });
            }
            else if ([input] == "displayCv") {
                this.setState({ [input]: e.target.checked });
                if (!e.target.checked) {
                    this.setState({ cv: null });
                }
            }
            else if ([input] == "displayLettre") {
                this.setState({ [input]: e.target.checked });
                if (!e.target.checked) {
                    this.setState({ lettre: null });
                }
            }
            else if ([input] == "cv") {
                this.setState({ [input]: e.currentTarget.files[0] });

            }
            else if ([input] == "lettre") {
                this.setState({ [input]: e.currentTarget.files[0] });
            }
            resolve();
        }
        );
        majState.then(() => {
            this.validerChamp([input]);
            this.setState({ step: this.state.step });
        });
    }

    render() {
        //découper le state:
        const { maxStep } = this.state;
        const { step } = this.state;
        const { erreurs } = this.state;
        const { idModaliteSuivi, idCampus, idFiliere, idFormation, idTypeFormation, idJourneeTest } = this.state;
        const journeeValues = { idModaliteSuivi, idCampus, idFiliere, idFormation, idTypeFormation, idJourneeTest };
        const { idCivilite, nom, prenom, adress, codepostal, ville, telephone, mail, naissance, idSituation, idNiveauEtude, etudeInformatique, salarieInformatique, displayCv, cv, displayLettre, lettre } = this.state;
        const candidatValues = { idCivilite, nom, prenom, adress, codepostal, ville, telephone, mail, naissance, idSituation, idNiveauEtude, etudeInformatique, salarieInformatique, displayCv, cv, displayLettre, lettre };
        const { etapeInscription } = this.state;
        const { loading, errorOnFetch } = this.state;
        const loadingValues = { loading, errorOnFetch };

        switch (step) {
            case 0:
                return (
                    <Loading values={loadingValues} />
                )
            case 1:
                return (
                    <div>
                        <ProgressBar key={step + "3"} step={step} maxStep={maxStep}/>
                        <Journee
                            nextStep={this.nextStep}
                            handleChange={this.handleChange}
                            values={journeeValues}
                            modalites={this.state.modalites}
                            campus={this.state.campus}
                            filieres={this.state.filieres}
                            typesFormations={this.state.typesFormations}
                            handleErreur={this.handleErreur}
                            CodeTypeJourneeInformation={this.state.CodeTypeJourneeInformation}
                        />
                        <CycleIngenieur />
                        <ReCAPTCHA
                            size="invisible"
                            sitekey="6Ldco0QUAAAAANnpvchqoG-wnVBcV0b0ubCG5mqD"
                            ref={this.reCaptacha}
                        />
                    </div>
                )
            case 2:
                return (
                    <div>
                        <ProgressBar key={step + "3"} step={step} maxStep={maxStep} />
                        <Candidat
                            prevStep={this.prevStep}
                            nextStep={this.nextStep}
                            handleChange={this.handleChange}
                            values={candidatValues}
                            civilites={this.state.civilites}
                            situations={this.state.situations}
                            niveauxEtude={this.state.niveauxEtude}
                            handleErreur={this.handleErreur}
                            CodeTypeJourneeInformation={this.state.CodeTypeJourneeInformation}
                        />
                        <ReCAPTCHA
                            size="invisible"
                            sitekey="6Ldco0QUAAAAANnpvchqoG-wnVBcV0b0ubCG5mqD"
                            ref={this.reCaptacha}
                        />
                    </div>
                )
            case 3:
                return (
                    <div>
                        <ProgressBar step={step} maxStep={maxStep} />
                        <Confirmation
                            etapeInscription={etapeInscription}
                        />
                        <ReCAPTCHA
                            size="invisible"
                            sitekey="6Ldco0QUAAAAANnpvchqoG-wnVBcV0b0ubCG5mqD"
                            ref={this.reCaptacha}
                        />
                    </div>
                )
            // never forget the default case, otherwise VS code would be mad!
            default:
            // do nothing
        }
    }
}
